import { Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faHome,
	faCogs,
	faSheetPlastic,
	faLayerPlus,
	faEnvelopes,
} from "@fortawesome/pro-solid-svg-icons";
import { faMobileAndroid } from "@fortawesome/pro-regular-svg-icons";
// import { faMoneyBill } from "@fortawesome/pro-regular-svg-icons";

export const adminHeaderMenuLeft = (
	<>
		{/* <div className="ant-menu-left-icon">
            <Link to="/subscribers/current">
                <span className="anticon">
                    <FontAwesomeIcon icon={faUsers} />
                </span>
                <Typography.Text>Subscribers</Typography.Text>
            </Link>
        </div> */}
	</>
);

export const adminHeaderDropDownMenuLeft = () => {
	const items = [
		// {
		//     key: "/subscribers/current",
		//     icon: <FontAwesomeIcon icon={faUsers} />,
		//     label: <Link to="/subscribers/current">Subscribers</Link>,
		// },
	];

	return <Menu items={items} />;
};

export const adminSideMenu = [
	{
		title: "Dashboard",
		path: "/dashboard",
		icon: <FontAwesomeIcon icon={faHome} />,
		moduleCode: "PAGE_DASHBOARD",
	},
	{
		title: "Faculty Monitoring",
		path: "/faculty-load",
		icon: <FontAwesomeIcon icon={faSheetPlastic} />,
		children: [
			{
				title: "List",
				path: "/faculty-load/list",
				moduleCode: "PAGE_FACULTY_MONITORING_LIST",
			},
			{
				title: "Justification",
				path: "/faculty-load/justification",
				moduleCode: "PAGE_FACULTY_MONITORING_JUSTIFICATION",
			},
			{
				title: "Deduction",
				path: "/faculty-load/deduction",
				moduleCode: "PAGE_FACULTY_MONITORING_DEDUCTION",
			},
			{
				title: "Absent List",
				path: "/faculty-load/absent-list",
				moduleCode: "PAGE_FACULTY_MONITORING_ABSENTS",
			},
			{
				title: "Present List",
				path: "/faculty-load/present-list",
				moduleCode: "PAGE_FACULTY_MONITORING_PRESENTS",
			},
			{
				title: "Report",
				path: "/faculty-load/reports",
				moduleCode: "PAGE_FACULTY_MONITORING_REPORTS",
			},
		],
	},
	{
		title: "Grade Submission",
		path: "/grade-tracker",
		icon: <FontAwesomeIcon icon={faLayerPlus} />,
		children: [
			{
				title: "List",
				path: "/grade-tracker/list",
				moduleCode: "PAGE_GRADE_SUBMISSION_LIST",
			},
			{
				title: "For Approval",
				path: "/grade-tracker/approval",
				moduleCode: "PAGE_GRADE_SUBMISSION_APPROVAL",
			},
			{
				title: "Approved List",
				path: "/grade-tracker/approved",
				moduleCode: "PAGE_GRADE_SUBMISSION_APPROVED",
			},
			{
				title: "Reports",
				path: "/grade-tracker/reports",
				moduleCode: "PAGE_GRADE_SUBMISSION_REPORTS",
			},
		],
	},
	// {
	// 	title: "Faculty",
	// 	path: "/faculty",
	// 	icon: <FontAwesomeIcon icon={faUsers} />,
	// 	moduleCode: "M-15",
	// },
	{
		title: "System Settings",
		path: "/system-settings",
		icon: <FontAwesomeIcon icon={faCogs} />,
		children: [
			{
				title: "General",
				path: "/system-settings/general",
				moduleCode: "PAGE_SYSTEM_SETTINGS_GENERAL",
			},
			{
				title: "Data Import",
				path: "/system-settings/data-import",
				moduleCode: "PAGE_SYSTEM_SETTINGS_DATA_IMPORT",
			},
		],
	},
	{
		title: "Email Template",
		path: "/email-template",
		icon: <FontAwesomeIcon icon={faEnvelopes} />,
		moduleCode: "PAGE_EMAIL_TEMPLATE",
	},
	{
		title: "MOBILE APK",
		path: "/mobile-apk",
		icon: <FontAwesomeIcon icon={faMobileAndroid} />,
		moduleCode: "PAGE_MOBILE_APK",
	},
];
